import React from 'react';
import { MediaList } from '@/features/wordpress/MediaList';
import { Header } from '@/components';

const Partner = () => {
  return (
    <>
      <Header />
      <MediaList />
    </>
  );
};

export default Partner;
